enum EFormFieldBlurScenario {
  PARAMETERS_SCENARIO = 'parametersScenario',
  LICENSE_SOURCE_SCENARIO = 'licenseSourceScenario',
  DEFAULT_SCENARIO = 'defaultScenario',
}

export default EFormFieldBlurScenario;
